import { formatShopifyPrice } from './theme.utils.js';

/**
 * Custom Quantity selector
 * When show_discounted_price is enabled in the buy button it will display the discounted price in the buy button
 */

function initializeQuantitySelector() {
  const buyButtonPrice = document.querySelector('.product-info__buy-buttons .discounted-price');
  document.querySelectorAll('.custom-select-wrapper').forEach(wrapper => {
      const originalSelect = wrapper.querySelector('.original-select');
      const trigger = wrapper.querySelector('.custom-select-trigger');
      const selectedValueSpan = wrapper.querySelector('.selected-value');
      const optionsList = wrapper.querySelector('.custom-options');
      const customOptions = optionsList.querySelectorAll('li');
      
      // Initialize selected value from the matching option so it matches what a click renders
      const initialOption = optionsList.querySelector(`li[data-value="${originalSelect.value}"]`);
      if (initialOption) {
        selectedValueSpan.innerHTML = initialOption.innerHTML;
      } else {
        selectedValueSpan.textContent = originalSelect.options[originalSelect.selectedIndex].textContent;
      }

      trigger.addEventListener('click', () => {
          optionsList.classList.toggle('open');
      });

      customOptions.forEach(option => {
          option.addEventListener('click', () => {
              const value = option.dataset.value;
              originalSelect.value = value;
              selectedValueSpan.innerHTML = option.innerHTML;
              optionsList.classList.remove('open');
              // Update selected class for styling
              customOptions.forEach(opt => opt.classList.remove('selected'));
              option.classList.add('selected');
              const originalTotal = option.dataset.price * option.dataset.value;
              const discountedTotal = option.dataset.discountedPrice * option.dataset.value;
              if (buyButtonPrice) {
                if (originalTotal == discountedTotal) {
                  buyButtonPrice.innerHTML = `<span>${formatShopifyPrice(originalTotal)}</span>`;
                  return;
                }
                buyButtonPrice.innerHTML = `<s class="text-subdued">${formatShopifyPrice(originalTotal, false)}</s> <span>${formatShopifyPrice(discountedTotal, false)}</span>`;
              }
          });
      });

      // Close when clicking outside
      document.addEventListener('click', (event) => {
          if (!wrapper.contains(event.target)) {
              optionsList.classList.remove('open');
          }
      });
    });
}


/**
 * Moves theme blocks inside the SealSubs widget once the app renders it: the quantity + buy buttons
 * below the more info container, and the "seal-subscription-text" text block below the interval
 * picker of the Subscribe & save option, hidden while that option is not selected
 */

function initializeSealsubsBlockPlacement() {
  const root = document.querySelector('.product-info') || document.body;
  const blockGroup = root.querySelector('[data-group-type="quantity-buy-buttons"]');
  const textBlock = root.querySelector('#seal-subscription-text');
  if (!blockGroup && !textBlock) return;

  textBlock?.classList.add('product-info__subscription-text');

  let scheduled = false;

  const place = () => {
    scheduled = false;
    const container = root.querySelector('.sealsubs-container');
    if (!container) return;

    if (blockGroup && !container.contains(blockGroup)) {
      const moreInfo = container.querySelector('.sls-more-info-container');
      if (moreInfo) {
        moreInfo.after(blockGroup);
      } else {
        container.append(blockGroup);
      }
    }

    if (!textBlock) return;

    const activeGroup = container.querySelector('.sls-option-container.sls-active[data-selling-plan-group]');
    if (!activeGroup) {
      textBlock.style.display = 'none';
      return;
    }

    const labelContainer = activeGroup.querySelector('.sls-label-container') || activeGroup;
    if (!labelContainer.contains(textBlock)) {
      labelContainer.append(textBlock);
    }
    textBlock.style.display = '';
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(place);
  };

  place();
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true, attributeFilter: ['class'] });
}

initializeSealsubsBlockPlacement();

document.addEventListener("DOMContentLoaded", () => {
  initializeQuantitySelector();
});

document.addEventListener("variant:change", () => {
  initializeQuantitySelector();
});